import { techimg1, techimg2, techimg3, techimg4, techimg5 } from "assets";

export const marqueeData = [
  {
    id: 1,

    hoverImage: techimg1,
  },
  {
    id: 2,

    hoverImage: techimg2,
  },
  {
    id: 3,

    hoverImage: techimg3,
  },
  {
    id: 4,

    hoverImage: techimg4,
  },
  {
    id: 5,

    hoverImage: techimg5,
  },
];
